module.exports = __webpack_public_path__ + "static/media/USGold® – USG – American Gold Eagle Coin.18384031.jpg";